import {DetailGrid, wdiCore} from "@/components/GridWidget";
import {initFieldDisplayFormater, TableColumnRanderFormats} from "@/components/WdiBus/TableColumnRanderFormats";
import {WdiCardTitle, WdiModalAppProps} from "@/components/WdiControls";
import {WdiModal} from "@/components/WdiControls/WdiModalForm";
import {GridApi} from "@/services/gridapi";
import React, {useEffect, useState} from "react";
import {FormSaDetail} from "@/services/sales/sa";
import {NsGrid} from "@/components/GridWidget/GridDefProps";
import {Enum} from "@/enums/system";
import {Button, Space} from "antd";
import {WdiPanel} from "@/components/WdiControls/WdiPanel";
import {toExcel} from "@/components/WdiControls/WdiExcel";


const initRowFieldConfigs = (record: any) => {
  return ["priceLimitBelowRate", "productFreeNames", "quantityBuy", "quantityFree", "tpmDetailId"];
};

const ViewProcessModalApp: React.FC<WdiModalAppProps> = (props) => {
  const [gridSettings, setGridSettings] = useState<any>({});
  const [isLoaded, setIsLoaded] = useState(false);
  const [dataSource, setDataSource] = useState<any[]>([]);

  useEffect(() => {
    if (props.id) {
      Promise.all([
        GridApi.searchConfig({id: 'FormSAViewProcess', allowModifyColumns: true}),
        FormSaDetail.getSaPdViewProcess(Number(props.id))
      ]).then((dataArray) => {
        const gridResp = dataArray[0];
        const saDetailResp = dataArray[1];
        setDataSource(saDetailResp.data);

        const settings: any = Object.assign({}, gridResp.data, {
          actionsAlign: NsGrid.ActionsAlign.None,
          showAggr: true,
          showExpandedRow: true,
        });

        settings.formSchema.allFields.rowNumber.width = 70;
        settings.formSchema.allFields.priceSellinBefore.width = 100;
        settings.formSchema.allFields.priceLimit.width = 80;
        settings.formSchema.allFields.priceSellinAfter.width = 110;
        settings.formSchema.allFields.quantityActual.width = 120;
        settings.formSchema.allFields.revenueActual.width = 135;
        settings.formSchema.allFields.amountActual.width = 135;

        settings.formSchema.allFields.quantityActual.aggr = TableColumnRanderFormats.sumAggr('quantityActual', 0);
        settings.formSchema.allFields.revenueActual.aggr = TableColumnRanderFormats.sumAggr('revenueActual', 2);
        settings.formSchema.allFields.amountActual.aggr = TableColumnRanderFormats.sumAggr('amountActual', 2);

        initFieldDisplayFormater(settings.formSchema.allFields);

        setGridSettings(settings);
        setIsLoaded(true);
      });
    }
  }, [props.id]);

  const pageGridSettings = Object.assign({
    antdProps: {
      dataSource: dataSource,
      initRowFieldConfigs: (record: any) => {
        return initRowFieldConfigs(record);
      },
      pagination: false
    }
  }, gridSettings);

  const exportDetails = () => {
    const columns = [
      {name: "ecName", displayName: "费用项"},
      {name: "revenueTypeName", displayName: "核算类型"},
      {name: "productBuyNames", displayName: "购买产品"},
      {name: "priceSellinBefore", displayName: "原供货价", type: Enum.FieldType.NUMBER},
      {name: "priceLimit", displayName: "限价", type: Enum.FieldType.NUMBER},
      {name: "priceSellinAfter", displayName: "促销供货价", type: Enum.FieldType.NUMBER},
      {name: "boName", displayName: "使用部门"},
      {name: "custSysCode", displayName: "客户组编号",},
      {name: "custSysName", displayName: "客户组名称",},
      {name: "soldToCode", displayName: "客户编号",},
      {name: "soldToName", displayName: "客户名称",},
      {name: "quantityActual", displayName: "实际出货销量", type: Enum.FieldType.NUMBER},
      {name: "revenueActual", displayName: "实际出货销售额", type: Enum.FieldType.NUMBER},
      {name: "amountActual", displayName: "当前实际花费", type: Enum.FieldType.NUMBER},
      {name: "priceLimitBelowRate", displayName: "低于限价比例", type: Enum.FieldType.NUMBER},
      {name: "productFreeNames", displayName: "赠送产品"},
      {name: "quantityBuy", displayName: "每套购买数量", type: Enum.FieldType.NUMBER},
      {name: "quantityFree", displayName: "每套赠送数量", type: Enum.FieldType.NUMBER},
      {name: "tpmDetailId", displayName: "活动明细编号"},
    ];
    const formSASheet = {
      data: dataSource,
      names: columns,
      sheetName: "活动执行情况",
    };
    toExcel({
      name: "活动执行情况_" + wdiCore.Date.ToString(new Date()) + ".xlsx",
      sheetProps: [formSASheet]
    });
  };

  return (
    <WdiModal
      title={props.title}
      visible={props.visible}
      width={1550}
      onCancel={() => {
        props.onClose?.()
      }}
      footer={false}
    >
      <WdiPanel
        title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='活动执行情况'/>} collapsed={false}
        extra={
          <Space>
            <Button type='primary' onClick={(e) => {
              e.stopPropagation();
              exportDetails();
            }}>
              导出
            </Button>
          </Space>
        }>
        {isLoaded && (
          <DetailGrid {...pageGridSettings} />
        )}
      </WdiPanel>
    </WdiModal>
  );
};

export default ViewProcessModalApp;
